import { ISiteBridgeSettingsForSiteAdmin } from '../../../settings/interfaces/ISiteSettingsForSiteAdmin';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetSiteBridgeSettingsForSiteAdminParams {
  id: string;
}

export type IGetSiteBridgeSettingsForSiteAdminResult = IResult & ISiteBridgeSettingsForSiteAdmin;

export class GetSiteBridgeSettingsForSiteAdminRequest
  extends Request<IGetSiteBridgeSettingsForSiteAdminParams, IGetSiteBridgeSettingsForSiteAdminResult>
{
  constructor(params: IGetSiteBridgeSettingsForSiteAdminParams) {
    super('getSiteBridgeSettingsForSiteAdmin', params);
  }
}
